export default {
  label: {
    importResume: '导入简历',
    uploadResume: '上传简历',
    import: '导入',
    signInWith: '当前网站',
    thirdPartyAccount: '电子邮箱/手机',
    thirdPartyPassword: '密码',
    resumeName: '简历名称',
    resumeCnName: '(中文)',
    resumeEnName: '(英文)',
    job51Channel: '前程无忧',
    jobStreetChannel: '求职工作街',
    resume: '简历'
  },
  btn: {
    signIn: '登录',
    cancel: '取消',
    import: '导入',
    skip: '跳过'
  },
  placeholder: {
    account: '请输入电子邮箱/手机',
    password: '请输入密码',
    platform: '请选择平台',
    resume: '请选择你的简历'
  },
  message: {
    needVerifyCode: '请输入验证码!',
    thirdPartyLoginError: '登录失败，请稍候再试！',
    UserNameOrPwdError: '用户名或密码错误！',
    UserMobileRequired: '手机号不能为空！',
    loginErrToManyTimes: '错误次数太多，请稍后再试！',
    tryLater: '请稍后重试！',
    loadResumeFailed: '加载简历失败！',
    confirmationAccount: '手机号或邮箱不存在，请确认后重新输入！',
    needPhoneBinding: '需要到智联招聘官网为此账号绑定手机号！ ',
    inputAccountFormatError: '您输入的手机号或邮箱格式不正确！',
    passwordShort: '密码只能是6-20位的字母数字和下划线！',
    needFetchSMSCode: '请输入短信验证码！',
    smsCodeError: '短信验证码错误！',
    praseFailure: '解析失败，请选择其他简历！',
    loginExpiration: '登录超时，请重新登录！',
    loadResumeFailedLater: '加载简历失败！请稍候再试'
  }
}
